import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericFilter } from '../models/GenericFilter';
import { GroupRoleClaim, GroupRoleClaimForCreation, ProjectGroupRolePermissionForCreation, ProjectGroupRolePermissionForUpdate, ProjectGroupRolePermissionToReturn, GroupRolesDto, GroupRoleUserDto, GroupRoleUsersDto, UserGroupRolesDto, RGrpRPGF, RoleGroupRoleProjectIds } from '../models/GroupRole';
import { UserRoleDto } from '../models/Identity/UserRole';
import { ProjectGroupRoleDto } from '../models/projectgrouprole';
import { ProjectGroupRoleUser, RoleDto, RolesDto } from '../models/SquirrelRoles';
import { BaseService } from './base.service';

@Injectable({ providedIn: 'root' })
export class ProjectRolesService extends BaseService {
  fetchTenantGroupRoleUsers(tenantdb: string, projectId: any, roleId: any, filter: GenericFilter) {
    throw new Error('Method not implemented.');
  }

  constructor(private httpClient: HttpClient) {
    super();
  }

  getRole(id: string): Observable<RoleDto> {
    return this.httpClient.get<RoleDto>(`${this.projectRoles}/${id}`);
  }

  getRoles(searchText: string, page?: number, pageSize?: number): Observable<RolesDto> {
    return this.httpClient.get<RolesDto>(`${this.projectRoles}?searchText=${searchText}&page=${page}&pageSize=${pageSize}`);
  }

  loadRoles(id: string, genericFilter: GenericFilter): Observable<RoleDto[]> {
    return this.httpClient.post<RoleDto[]>(`${this.projectRoles}/${id}/GetFilteredProjectRoles`, genericFilter);
  }

  // getGetUserIds(roleId: string): Observable<string[]> {
  //   return this.httpClient.get<string[]>(`${this.projectRoles}/${roleId}/GetUserIds`);
  // }

  createRole(newRole: RoleDto): Observable<RoleDto> {
    return this.httpClient.post<RoleDto>(`${this.projectRoles}`, newRole);
  }

  updateRole(roleToUpdate: RoleDto): Observable<RoleDto> {
    return this.httpClient.put<RoleDto>(`${this.projectRoles}`, roleToUpdate);
  }

  deleteRole(id: string) {
    return this.httpClient.delete(`${this.projectRoles}/${id}`);
  }

  // createProjectGroupRoleUser(projectGroupRoleUser: ProjectGroupRoleUser): Observable<ProjectGroupRoleUser> {
  //   return this.httpClient.post<ProjectGroupRoleUser>(`${this.projectGroupRoles}/ProjectGroupRoleUser`, projectGroupRoleUser);
  // }

  createUserRole(userGroupRole: UserRoleDto): Observable<UserRoleDto> {
    return this.httpClient.post<UserRoleDto>(`${this.projectRoles}/GroupRole`, userGroupRole);
  }

  getGroupRoles(searchText: string, page?: number, pageSize?: number): Observable<GroupRolesDto> {
    return this.httpClient.get<GroupRolesDto>(`${this.projectRoles}/GroupRole?searchText=${searchText}&page=${page}&pageSize=${pageSize}`);
  }

  getGroupRoleUsers(searchText: string, roleId: string, page?: number, pageSize?: number): Observable<GroupRoleUsersDto> {
    return this.httpClient.get<GroupRoleUsersDto>(`${this.projectRoles}/${roleId}/users?searchText=${searchText}&page=${page}&pageSize=${pageSize}`);
  }

  // loadGroupRoleUsers(projectId:string, roleId:string, genericFilter: GenericFilter): Observable<GroupRoleUserDto[]> {   
  //   return this.httpClient.post<GroupRoleUserDto[]>(`${this.projectRoles}/${projectId}/GetFilteredGroupRoleUsers/${roleId}`, genericFilter);
  // }

  getGroupRoleClaims(roleId: string, page?: number, pageSize?: number): Observable<UserGroupRolesDto> {
    return this.httpClient.get<UserGroupRolesDto>(`${this.projectRoles}/${roleId}/GroupRoleClaims?page=${page}&pageSize=${pageSize}`);
  }

  createGroupRoleClaims(roleDto: RoleDto): Observable<RoleDto> {
    console.log(roleDto)
    return this.httpClient.post<RoleDto>(`${this.projectRoles}/GroupRoleClaims`, roleDto);
  }

  updateGroupRoleClaims(groupRoleClaim: GroupRoleClaimForCreation, roleId: string): Observable<GroupRoleClaimForCreation> {
    return this.httpClient.post<GroupRoleClaimForCreation>(`${this.projectRoles}/${roleId}/AddGroupRoleClaim`, groupRoleClaim);
  }
  
  // deleteUserFromGroupRole(projectId: string, roleId: string, userId: string): Observable<any> {
  //   return this.httpClient.delete<any>(`${this.projectRoles}/${userId}/DeleteUserGroupRole/${projectId}/${roleId}`);
  // }

  getProjectGroupRolePermissions(groupRoleId: string): Observable<ProjectGroupRolePermissionToReturn[]> {
    return this.httpClient.get<ProjectGroupRolePermissionToReturn[]>(`${this.projectRoles}/${groupRoleId}/GetProjectGroupRolePermissions`);
  }

  createProjectGroupRolePermission(grpRolePermission: ProjectGroupRolePermissionForCreation): Observable<ProjectGroupRolePermissionForCreation> {
    return this.httpClient.post<ProjectGroupRolePermissionForCreation>(`${this.projectRoles}/CreateProjectGroupRolePermission`, grpRolePermission);
  }

  updateProjectGroupRolePermission(groupRolePermissionForUpdate: ProjectGroupRolePermissionForUpdate): Observable<any> {
    return this.httpClient.put<any>(`${this.projectRoles}/UpdateProjectGroupRolePermission`, groupRolePermissionForUpdate);
  }

  deleteProjectGroupRolePermission(id: string): Observable<any> {
    return this.httpClient.delete<any>(`${this.projectRoles}/${id}/DeleteProjectGroupRolePermission`);
  }

}